import { CommonEntrypoint } from 'entrypoint/CommonEntrypoint';
import { ProposalEnquiryProvider } from 'presentation/store/ProposalEnquiry/ProposalEnquiryProvider';
import 'presentation/style/chargeDataEnquiry/chargeDataSearch.scss';
import 'presentation/style/index.scss';
import { ProposalEnquiryContainer } from 'presentation/view/container/ProposalEnquiry/ProposalEnquiryContainer';
import { ProposalEnquiryHeaderContainer } from 'presentation/view/container/ProposalEnquiry/ProposalEnquiryHeaderContainer';

CommonEntrypoint(<ProposalEnquiryContainer />, <ProposalEnquiryHeaderContainer />, ProposalEnquiryProvider)